import type { TFunction } from 'i18next'

import FormGroup from '../../formComponents/FormGroup'
import InputField from '../../formComponents/InputField'

type PageDuplicatePanelProps = {
  tModal: TFunction
}

export function PageDuplicatePanel({ tModal }: Readonly<PageDuplicatePanelProps>) {
  return (
    <FormGroup
      key="pageName"
      tagName="label"
      name="title"
      label={tModal('pageNameInputField.label') + '*'}
      title={tModal('pageNameInputField.tooltip')}
    >
      <InputField name="title" type="text" maxLength={100} />
    </FormGroup>
  )
}
